import {
  fetchChannels,
  fetchChannelsFailure,
  fetchChannelsFulfill,
  fetchChannelsSuccess,
} from '@src/reducers/channels';

import B2ChatClient from '@client-sdk';
import { channelsSelector } from '@src/selectors/channels';
import { isErrorPayload } from '@src/services/service';
import { ChannelMap, Channels } from '@src/types/channels';
import { B2ChatAPI } from '@types-api';
import { call, put, select, takeLatest } from 'redux-saga/effects';

function* fetchChannelsByIdSaga({ payload }: ReturnType<typeof fetchChannels>) {
  try {
    const channels: ChannelMap = yield select(channelsSelector);
    const ids = payload?.filter(id => !channels[id]) ?? undefined;

    if (!ids?.length) {
      return;
    }

    const response: B2ChatAPI.Response<Channels> = yield call(
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      B2ChatClient.resources.channels.actions.getChannels,
      { params: { 'ids[]': ids } }
    );

    if (response.error) throw response.error;

    const channelsMap: ChannelMap = {};

    payload?.forEach(id => {
      channelsMap[id] =
        channels[id] || response.data.find(channel => channel.id === id);
    });

    yield put(fetchChannelsSuccess(channelsMap));
  } catch (error) {
    if (isErrorPayload(error)) {
      yield put(fetchChannelsFailure(error));
    } else {
      yield put(
        fetchChannelsFailure({
          errorCode: 'UNKNOWN',
          details: (error as Error).message,
        })
      );
    }
  } finally {
    yield put(fetchChannelsFulfill());
  }
}

function* ChannelsSaga() {
  yield takeLatest(fetchChannels, fetchChannelsByIdSaga);
}

export default ChannelsSaga;
